import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import style from './NameField.module.scss';

interface INameField {
	changeName: (value: string) => void;
}

const NameField: React.FC<INameField> = ({ changeName }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterName') }], [t]);

	return (
		<FormInput
			containerClassName={style.input}
			testId="NameField"
			name="name"
			label="nameLabel"
			maxLength={50}
			onChange={changeName}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(NameField);
